import { writable } from "svelte/store";

let OrderMessagesViewerStore;
export default OrderMessagesViewerStore = writable({});
